export const SYSTEM_PROPS = {
  m: {
    type: 'spacing',
    property: 'margin'
  },
  mt: {
    type: 'spacing',
    property: 'marginTop'
  },
  mb: {
    type: 'spacing',
    property: 'marginBottom'
  },
  ml: {
    type: 'spacing',
    property: 'marginLeft'
  },
  mr: {
    type: 'spacing',
    property: 'marginRight'
  },
  mx: {
    type: 'spacing',
    property: ['marginRight', 'marginLeft']
  },
  my: {
    type: 'spacing',
    property: ['marginTop', 'marginBottom']
  },
  p: {
    type: 'spacing',
    property: 'padding'
  },
  pt: {
    type: 'spacing',
    property: 'paddingTop'
  },
  pb: {
    type: 'spacing',
    property: 'paddingBottom'
  },
  pl: {
    type: 'spacing',
    property: 'paddingLeft'
  },
  pr: {
    type: 'spacing',
    property: 'paddingRight'
  },
  px: {
    type: 'spacing',
    property: ['paddingRight', 'paddingLeft']
  },
  py: {
    type: 'spacing',
    property: ['paddingTop', 'paddingBottom']
  },
  w: {
    type: 'size',
    property: 'width'
  },
  miw: {
    type: 'size',
    property: 'minWidth'
  },
  maw: {
    type: 'size',
    property: 'maxWidth'
  },
  h: {
    type: 'size',
    property: 'height'
  },
  mih: {
    type: 'size',
    property: 'minHeight'
  },
  mah: {
    type: 'size',
    property: 'maxHeight'
  },
  bg: {
    type: 'color',
    property: 'background'
  },
  c: {
    type: 'color',
    property: 'color'
  },
  fill: {
    type: 'color',
    property: 'fill'
  },
  opacity: {
    type: 'identity',
    property: 'opacity'
  },
  pos: {
    type: 'identity',
    property: 'position'
  },
  top: {
    type: 'spacing',
    property: 'top'
  },
  left: {
    type: 'spacing',
    property: 'left'
  },
  bottom: {
    type: 'spacing',
    property: 'bottom'
  },
  right: {
    type: 'spacing',
    property: 'right'
  },
  display: {
    type: 'identity',
    property: 'display'
  },
  flex: {
    type: 'identity',
    property: 'flex'
  },
  flexGrow: {
    type: 'identity',
    property: 'flexGrow'
  },
  flexShrink: {
    type: 'identity',
    property: 'flexShrink'
  },
  flexBasis: {
    type: 'identity',
    property: 'flexBasis'
  },
  alignContent: {
    type: 'identity',
    property: 'alignContent'
  },
  alignItems: {
    type: 'identity',
    property: 'alignItems'
  },
  alignSelf: {
    type: 'identity',
    property: 'alignSelf'
  },
  flexDirection: {
    type: 'identity',
    property: 'flexDirection'
  },
  justifyContent: {
    type: 'identity',
    property: 'justifyContent'
  },
  flexWrap: {
    type: 'identity',
    property: 'flexWrap'
  },
  order: {
    type: 'identity',
    property: 'order'
  },
  gap: {
    type: 'spacing',
    property: 'gap'
  },
  overflow: {
    type: 'identity',
    property: 'overflow'
  },
  overflowX: {
    type: 'identity',
    property: 'overflowX'
  },
  overflowY: {
    type: 'identity',
    property: 'overflowY'
  },
  zIndex: {
    type: 'identity',
    property: 'zIndex'
  },
  ta: {
    type: 'identity',
    property: 'textAlign'
  },
  va: {
    type: 'identity',
    property: 'verticalAlign'
  },
  fontSize: {
    type: 'size',
    property: 'fontSize'
  },
  fw: {
    type: 'identity',
    property: 'fontWeight'
  },
  bs: {
    type: 'identity',
    property: 'borderStyle'
  },
  bc: {
    type: 'color',
    property: 'borderColor'
  },
  bw: {
    type: 'size',
    property: 'borderWidth'
  },
  btw: {
    type: 'size',
    property: 'borderTopWidth'
  },
  bbw: {
    type: 'size',
    property: 'borderBottomWidth'
  },
  blw: {
    type: 'size',
    property: 'borderLeftWidth'
  },
  brw: {
    type: 'size',
    property: 'borderRightWidth'
  },
  br: {
    type: 'size',
    property: 'borderRadius'
  },
  btr: {
    type: 'size',
    property: ['borderTopLeftRadius', 'borderTopRightRadius']
  },
  bbr: {
    type: 'size',
    property: ['borderBottomLeftRadius', 'borderBottomRightRadius']
  },
  btlr: {
    type: 'size',
    property: 'borderTopLeftRadius'
  },
  btrr: {
    type: 'size',
    property: 'borderTopRightRadius'
  },
  bblr: {
    type: 'size',
    property: 'borderBottomLeftRadius'
  },
  bbrr: {
    type: 'size',
    property: 'borderBottomRightRadius'
  },
  transition: {
    type: 'identity',
    property: 'transition'
  },
  transform: {
    type: 'identity',
    property: 'transform'
  },
  backgroundImage: {
    type: 'identity',
    property: 'backgroundImage'
  },
  backgroundSize: {
    type: 'identity',
    property: 'backgroundSize'
  },
  backgroundRepeat: {
    type: 'identity',
    property: 'backgroundRepeat'
  },
  backgroundPosition: {
    type: 'identity',
    property: 'backgroundPosition'
  },
  objectFit: {
    type: 'identity',
    property: 'objectFit'
  },
  aspectRatio: {
    type: 'identity',
    property: 'aspectRatio'
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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